import React, { useState, useRef, useEffect } from 'react';
import '../../styles-wa/template_action_menu.css';

const TemplateActionMenu = ({
  template,
  onPreview,
  onArchive,
  onDelete,
  isArchived = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleAction = (action) => {
    setIsOpen(false);
    if (action === 'preview') {
      onPreview?.();
    } else if (action === 'archive') {
      onArchive?.();
    } else if (action === 'delete') {
      onDelete?.();
    }
  };

  return (
    <div className="template-action-menu" ref={menuRef}>
      <button
        className="menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="More options"
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>

      {isOpen && (
        <div className="menu-dropdown">
          <button
            className="menu-item preview-item"
            onClick={() => handleAction('preview')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <span>Preview</span>
          </button>

          <button
            className="menu-item archive-item"
            onClick={() => handleAction('archive')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="21 8 21 21 3 21 3 8" />
              <line x1="1" y1="3" x2="23" y2="3" />
              <path d="M10 12v5M14 12v5" />
            </svg>
            <span>{isArchived ? 'Restore' : 'Archive'}</span>
          </button>

          <div className="menu-divider" />

          <button
            className="menu-item delete-item"
            onClick={() => handleAction('delete')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              <line x1="10" y1="11" x2="10" y2="17" />
              <line x1="14" y1="11" x2="14" y2="17" />
            </svg>
            <span>Delete</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default TemplateActionMenu;



